/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoStatusDisplayDTO } from './geoStatusDisplayDTO';
import { GeoAlertDTO } from './geoAlertDTO';
import { GeoTestRegionDetailDTO } from './geoTestRegionDetailDTO';
import { GeoTestMetricsDTO } from './geoTestMetricsDTO';
import { GeoTacticTableRowDTO } from './geoTacticTableRowDTO';
import { GeoCampaignDTO } from './geoCampaignDTO';
import { GeoTestPermissionsDTO } from './geoTestPermissionsDTO';
import { GeoTestImplementationSwitchDTO } from './geoTestImplementationSwitchDTO';
import { GeoTestScheduleDTO } from './geoTestScheduleDTO';


export interface GeoTestDetailResponseDTO {
    testId: number;
    testName: string;
    businessQuestion?: string;
    status: GeoTestDetailResponseDTO.StatusEnum;
    testCellConfigId: number;
    bauCellConfigId: number;
    displayStatus?: GeoStatusDisplayDTO;
    testType: GeoTestDetailResponseDTO.TestTypeEnum;
    implementation: GeoTestDetailResponseDTO.ImplementationEnum;
    selectedTacticIds: Array<string>;
    selectedTactics?: Array<GeoTacticTableRowDTO>;
    conversionTypeIds: Array<number>;
    conversionTypeNames: Array<string>;
    conversionTypesMap?: object;
    testRegions: GeoTestRegionDetailDTO;
    campaigns: Array<GeoCampaignDTO>;
    testSchedule?: GeoTestScheduleDTO;
    metrics: GeoTestMetricsDTO;
    currencyCode?: string;
    compositeDataSourceId?: number;
    permissions: GeoTestPermissionsDTO;
    implementationSwitch?: GeoTestImplementationSwitchDTO;
    createdBy: string;
    createdAt: string;
    modifiedBy: string;
    modifiedAt: string;
    kpiType?: string;
    kpiStateHistory?: 'SINGLE_TO_MULTIPLE' | 'MULTIPLE_TO_MULTIPLE' | 'SINGLE_TO_MULTIPLE_IN_RETRO' | 'MULTIPLE_TO_MULTIPLE_IN_RETRO' | undefined;
    parentId?: number | null;
    multiKpiPrimaryStudyId?: number;
    isMultiKpiParent?: boolean;
    childTests?: Array<GeoTestDetailResponseDTO>;
    alerts?: Array<GeoAlertDTO>;
}
export namespace GeoTestDetailResponseDTO {
    export type StatusEnum = 'DRAFT' | 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Active: 'ACTIVE' as StatusEnum,
        Inactive: 'INACTIVE' as StatusEnum
    };
    export type TestTypeEnum = 'Holdout' | 'Scale' | 'Contribution';
    export const TestTypeEnum = {
        Holdout: 'Holdout' as TestTypeEnum,
        Scale: 'Scale' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
    export type ImplementationEnum = 'AUTOMATIC' | 'MANUAL';
    export const ImplementationEnum = {
        Automatic: 'AUTOMATIC' as ImplementationEnum,
        Manual: 'MANUAL' as ImplementationEnum
    };
}


